(ns hypnos.backoffice.bar.title
  "The title bar."
  (:require [hypnos.i18n :refer [tr]]
            [medley.core :as mc]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Identities

(def ^{:const true :private true} panels
  {:dashboard-panel {:label :ui.label/home
                     :link  "/dashboard"}
   :iris-panel      {:label :ui.label/iris
                     :link  "/iris"}
   :patients-panel  {:label :ui.label/patients
                     :link  "/patients"}
   :patient-panel   {:label :ui.label/patient
                     :link  "/patient"}})

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- organization-key-field
  "Organization drop down."
  [user org-id]
  (let [user-orgs (:user/organizations user)]
    (if (< 1 (count user-orgs))
      [:div.field-body
       [:div.field.is-narrow
        [:div.control
         [:div.select
          [:select
           {:type      :text
            :value     (str org-id)
            :on-change (fn [e]
                         (let [new-value (-> e .-target .-value)]
                           (rf/dispatch [:backoffice/set-organization (mc/uuid new-value)])))}
           (for [org user-orgs]
             [:option {:key (str (:organization/id org)) :value (str (:organization/id org))} (str (:organization/key org))])]]]]]
      (:organization/key (first user-orgs)))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Bar

(defn bar
  "The title bar"
  []
  (let [organization (rf/subscribe [:backoffice/organization])
        user         (rf/subscribe [:backoffice/user])
        patient      (rf/subscribe [:backoffice/patient])
        panel        (rf/subscribe [:backoffice/active-panel])]
    [:section.section.is-title-bar
     [:div.level
      [:div.level-left
       [:div.level-item
        [:ul
         [:li [:a {:href (:link (panels (:name @panel)))} (tr (:label (panels (:name @panel))))]]
         ;; panel name
         (if @patient
           (for [item [(get-in @patient [:patient/organization :organization/key])
                       (or (:patient/key @patient) (:patient/id @patient))]]
             ^{:key item} [:li item])
           (when-let [org-id (:organization/id @organization)]
             [:li [organization-key-field @user org-id]]))]]]]]))
